import "./style.css";
import React, { useEffect, useState } from "react";

import portfolioImage from "assets/portrait/portfolio-image.jpg";

import Navbar from "components/Navbar";
import Logo from "components/Logo";
import Container from "components/Container";
import { NavLink } from "react-router";

export default function Header() {
	const [position, setPosition] = useState(window.scrollY);
	const [showHeader, setShowHeader] = useState(true);

	useEffect(() => {
		const handleScroll = () => {
			let moving = window.scrollY;

			setShowHeader(position > moving);
			setPosition(moving);
		};
		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	});

	return (
		<header
			className={`header ${
				showHeader ? "visible" : "hidden"
			}`}
		>
			<Container containerClass="header-container">
				<NavLink to="/" className="logo-link" title="Hem">
					<Logo image={portfolioImage} text="Abraham Eishow" />
				</NavLink>
				<Navbar />
			</Container>
		</header>
	);
}
